import { render, staticRenderFns } from "./externalUserLogin.vue?vue&type=template&id=66bbc6a3&scoped=true"
import script from "./externalUserLogin.vue?vue&type=script&lang=js"
export * from "./externalUserLogin.vue?vue&type=script&lang=js"
import style0 from "./externalUserLogin.vue?vue&type=style&index=0&id=66bbc6a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bbc6a3",
  null
  
)

export default component.exports